import cn from 'classnames';
import { BrandsFilterProps } from './types';

const BrandsFilter = ({
  brands,
  isLoading,
  searchInput,
  handleFilterChange,
}: BrandsFilterProps) => {
  if (!brands || brands.length <= 1) return null;

  const sortedBrands = [...brands].sort((a, b) => b.count - a.count);

  return (
    <div
      // eslint-disable-next-line tailwindcss/no-custom-classname
      className="hide-scrollbar flex flex-nowrap gap-1 overflow-hidden overflow-x-scroll"
    >
      {sortedBrands.map((brand) => {
        const isSelected = searchInput.variantFilters?.brand?.includes(
          brand.key,
        );

        return (
          <button
            key={brand.key}
            className={cn(
              'flex h-10 shrink-0 items-center justify-center rounded-md border px-3 text-sm outline-none transition duration-100 ease-in-out disabled:opacity-40',
              {
                'border-gray-700': isSelected,
                'hover:cursor-pointer hover:border-gray-700':
                  !isLoading && !isSelected,
              },
            )}
            onClick={() => handleFilterChange('brand', brand.key, !isSelected)}
            disabled={isLoading}
          >
            {brand.key}
          </button>
        );
      })}
    </div>
  );
};

export default BrandsFilter;
